import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

const ButtonBlock = ({ formIsValid, onBack, onDone }) => {
    return (
        <div className="financing__content-btn-section">
            {onBack && (
                <button onClick={() => onBack()} disabled={!formIsValid} type="button" className="sr-link">
                    {LocaleService.t('FINANCING.BACK')}
                </button>
            )}
            {onDone && (
                <button onClick={() => onDone()} disabled={!formIsValid} className="sr-button-1 is-small">
                    {LocaleService.t('FINANCING.DONE')}
                </button>
            )}
        </div>
    );
};

ButtonBlock.defaultProps = {
    formIsValid: true,
    onBack: null,
    onDone: null,
};

ButtonBlock.propTypes = {
    formIsValid: PropTypes.bool,
    onBack: PropTypes.func,
    onDone: PropTypes.func,
};

ButtonBlock.displayName = 'ButtonBlock';

export default ButtonBlock;
